<template>
  <div id="app"
       class="backgroudbg">

    <div class=" margin-center   margin-top-15 lectrue">
      <div class="bg-white author">
        <img :src="imageUrl"
             style="width:100px;height: 100px;">

      </div>
      <div class="bg-white des">
        <div class="p1">
          <p style="flex:1"> {{name}}</p>
          <p style="width:100px;line-height: 30px;  text-align: center;">{{dataList.length}}</p>
        </div>

        <div class="p2 ">
          <p style="flex:1"
             class="text-line1">{{infor}}</p>
          <p style="width:100px;  text-align: center;">课程数</p>
        </div>

      </div>
    </div>
    <div class=" bg-white margin-center   margin-top-15 backgroud"
         style="padding-top:26px;min-height: 550px;">

      <div class="flex flex-wrap">
        <div v-for="(item, index) in dataList"
             :key="index"
             style="width: 280px;height: 254px; overflow: hidden;margin-left:20px; position: relative;"
             @click="clickVideo(item.Id,0)">
         <div style=" width: 280px;height: 168px;">
          <img style=" width: 280px;height: 168px;" :src="item.Image"  alt="">
        </div>
        <div class="backhover">
          <!-- :style="{backgroundImage:'url('+item.Image+')'}" -->

          <div>
            <i class="subMask"></i>
            <i class="playIcon"></i>
          </div>
        </div>
          <p :title="item.Title"
             class="font-color-333-red text-line1  font-size-16"
             style="text-decoration: none;text-align: left;line-height: 20px;margin-top: 15px;cursor: pointer;">{{item.Title}}</p>

          <p class="text-line1 font-color-999 text-left font-size-12"
             style="margin-top:3px;">主讲人：{{item.Lecturer}}</p>
        </div>
      </div>
    </div>

    <Bottom></Bottom>
  </div>
</template>

<script>
export default {
  name: 'app',

  data () {
    return {
      Id: 0,
      dataList: [],
      name: "",
      infor: '',
      imageUrl: '',

    }
  },


  created () {
    this.Id = this.$route.query.Id || 0
    if (this.key == 0) {
      this.$router.push({ name: 'home' })
    } else {
      this.getCourseList()

    }
  },
  methods: {




    getCourseList (index) {
      var that = this;
      this.getRequest('api/v1/authorinfo/GetAuthorById', {
        Id: this.Id
      }).then(data => {
        if (data.IsSuccess) {
          that.dataList = data.Data.Courses.DataList
          that.name = data.Data.Name
          that.infor = data.Data.Infos
          that.imageUrl = data.Data.AuthorImage
        } else {
          this.$message.error(data.Message)
        }
      })
    },

    clickVideo: function (courseId, videoId) {


      let routeData = this.$router.resolve({
        name: "video",
        params: {
          sizheng: "n",
          courseId: courseId,
          videoId: videoId
        }
      });
      window.open(routeData.href, '_blank');
    },
  }
}
</script>

<style scoped>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

body {
  background: #ffffff;
  padding: 0 0;
}
.backgroudbg {
  background-image: url(../../assets/img/lecture.png);
  background-repeat: no-repeat;
  background-position: center;
}
.backgroud {
  width: 1220px;

  background: #ffffff;
  box-shadow: 0px 3px 20px 0px #ececec;
}

.lectrue {
  margin-top: 33px;
  width: 1220px;
}
.lectrue .author {
  width: 110px;
  height: 110px;
  padding: 5px;
  overflow: hidden;
  margin-left: 15px;
}
.lectrue .des {
  width: 100%;
  height: 86px;

  margin-top: -71px;
  padding-left: 139px;
}
.lectrue .des .p1 {
  color: #4c4948;
  text-align: left;
  font-weight: bold;
  line-height: 48px;
  font-size: 24px;
  display: flex;
  align-items: flex-end;
}

.lectrue .des .p2 {
  color: #999999;
  display: flex;
  text-align: left;
  font-size: 12px;
  font-weight: bold;
  line-height: 20px;
}
.backhover {
  width: 280px;
  height: 168px;
  overflow: hidden;
  margin-top: -168px;
  background-size: cover;
  background-repeat: no-repeat;
}

.backhover div {
  position: relative;
  display: block;
  width: 100%;
  height: 100%;
  cursor: pointer;
}

.backhover .subMask {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #000;
  opacity: 0.3;
  filter: alpha(opacity=30);
  z-index: 0;
}

.backhover .playIcon {
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 6;
  opacity: 0;
  margin: -30px 0 0 -30px;
  width: 60px;
  height: 60px;
  background: url(https://h5.cdn.bjadks.com/website/wsbgt-zt/999-linshi_szk/play-icon1.png)
    no-repeat;
  filter: alpha(opacity=0);
  -webkit-transition: all 0.3s ease-out;
  -moz-transition: all 0.3s ease-out;
  -ms-transition: all 0.3s ease-out;
  -o-transition: all 0.3s ease-out;
  transition: all 0.3s ease-out;
  -webkit-transform: scale(1.5);
  -moz-transform: scale(1.5);
  -ms-transform: scale(1.5);
  transform: scale(1.5);
}

.backhover div:hover .subMask {
  display: block;
  z-index: 5;
}

.backhover div:hover .playIcon {
  z-index: 6;
  opacity: 1;
  filter: alpha(opacity=100);
  transform: scale(1);
  -webkit-transform: scale(1);
  -moz-transform: scale(1);
  -ms-transform: scale(1);
  transform: scale(1);
}
</style>



// WEBPACK FOOTER //
// src/views/lecture/index.vue